import { useLocation, useNavigate } from 'react-router-dom'

import {
  getDataAccessRequestsListPath,
  getExportAnalysisListPath,
  getImportRequestsListPath,
  getRequestsBasePath,
  isAirlockRequestsV3RoutesEnabled,
  isDataAccessRequestsListPath,
  isImportRequestsListPath
} from 'modules/requests/requestDetailPaths'
import {
  ExportAndAccessSubTabKeys,
  type RequestsTabKey,
  RequestsTabKeys,
  isRequestsTabKey
} from 'modules/requests/requestsTabKeys'

const getActiveTabKey = (pathname: string): RequestsTabKey => {
  if (isImportRequestsListPath(pathname)) {
    return RequestsTabKeys.Import
  }

  if (isAirlockRequestsV3RoutesEnabled() && isDataAccessRequestsListPath(pathname)) {
    return RequestsTabKeys.DataAccess
  }

  if (isAirlockRequestsV3RoutesEnabled()) {
    return RequestsTabKeys.Export
  }

  return RequestsTabKeys.ExportAndAccess
}

export const useRequestsPage = (): {
  activeTabKey: RequestsTabKey
  exportTabKey: RequestsTabKey
  exportTabName: string
  isDataAccessTabEnabled: boolean
  onSelectTab: (tabKey: string) => void
} => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isV3RoutesEnabled = isAirlockRequestsV3RoutesEnabled()

  const activeTabKey = getActiveTabKey(pathname)
  const exportTabKey = isV3RoutesEnabled ? RequestsTabKeys.Export : RequestsTabKeys.ExportAndAccess
  const exportTabName = isV3RoutesEnabled ? 'Exports' : 'Export & access'
  const isDataAccessTabEnabled = isV3RoutesEnabled

  const onSelectTab = (tabKey: string) => {
    if (!isRequestsTabKey(tabKey)) return

    if (tabKey === RequestsTabKeys.Import) {
      navigate(getImportRequestsListPath())
      return
    }

    if (tabKey === RequestsTabKeys.DataAccess) {
      if (!isV3RoutesEnabled) return

      navigate(getDataAccessRequestsListPath())
      return
    }

    const subTab =
      pathname === getExportAnalysisListPath() ? ExportAndAccessSubTabKeys.Analysis : ExportAndAccessSubTabKeys.Files

    navigate(`${getRequestsBasePath()}/${exportTabKey}/${subTab}`)
  }

  return {
    activeTabKey,
    exportTabKey,
    exportTabName,
    isDataAccessTabEnabled,
    onSelectTab
  }
}
